import { useState } from "react";
import { Box, Card, CardBody, FileInput, Text, Spinner, Anchor } from "grommet";
import { API } from "aws-amplify";
import ProcessUpload from "./process-upload";

export interface FileUploadComponentProps {
  handleUploadSliders(upload_values: Array<number>): void;
}

export default function FileUploadComponent({ handleUploadSliders }: FileUploadComponentProps) {
  const [ecg, setECG] = useState<any>();
  const [uploadMessage, setUploadMessage] = useState<string>("");

  let fileReader: FileReader;

  const sendECGData = (ecg_data: Array<any>) => {
    const apiName = "encodeECG";
    const path = "/encode";

    const myInit = {
      body: ecg_data,
    };

    console.log(myInit);

    API.post(apiName, path, myInit)
      .then((response: any) => {
        console.log(response);
        handleUploadSliders(response.encoding);
        setUploadMessage("Succesfully encoded ECG file, please find the prediction on the right side");
      })
      .catch((error: any) => {
        console.log(error.response);
        setUploadMessage("Error sending ECG file");
      });
  };

  const handleFileRead = () => {
    if (fileReader.result) {
      const data = ProcessUpload(fileReader, setUploadMessage);
      if (data.length !== 0) {
        sendECGData(data);
      }
    }
  };

  const handleSubmission = (selectedFile: any) => {
    fileReader = new FileReader();
    fileReader.onloadend = handleFileRead;
    fileReader.readAsArrayBuffer(selectedFile);
  };

  const changeHandler = (event: any) => {
    if (event.target.files) {
      const selectedFile = event.target.files[0];
      setUploadMessage("Processing");
      handleSubmission(selectedFile);
    } else {
      setUploadMessage("");
    }
  };

  return (
    <div>
      <Text>
        You can upload your own ECG below to test the algorithm. This currently only works for XML files as exported by the GE MUSE ECG
        system. The file is first completely anonymized locally (on your own pc), so no patient information is uploaded anywhere. Please
        note that this is for research use only. A tool for batches of ECGs is available{" "}
        <Anchor href="https://encoder.ecgx.ai">here</Anchor>.
      </Text>
      <Box pad={{ top: "medium", bottom: "medium" }}>
        <FileInput name="file" onChange={changeHandler} />
      </Box>
      {uploadMessage && (
        <Card background={uploadMessage.startsWith("Error") ? "#f5b0b0" : "#bdd4b2"}>
          <CardBody pad="small" align="center">
            {uploadMessage == "Processing" ? (
              <Spinner color="white" />
            ) : (
              <Text textAlign="center" weight="bold">
                {uploadMessage}
              </Text>
            )}
          </CardBody>
        </Card>
      )}

      {/* {ecg && (
        <LineCanvas
          data={ecg}
          height={100}
          width={200}
          enablePoints={false}
          yScale={{ type: "linear", stacked: false, min: -200, max: 200 }}
        />
      )} */}
    </div>
  );
}
